<div class="overflow-y-auto  px-3 h-full bg-white border-r border-gray-200 dark:bg-gray-800 dark:border-gray-700">
  <ul class="space-y-2">
    <li *ngFor="let project of projects">
      <ng-container *ngIf="project?.project_id?.is_deleted != 1 && project?.project_id ">
        <a routerLink="/project/{{project?.project_id?._id}}/exceptions" (click)="onClickProject(project)"
          [ngClass]="{'active-menu': project?.project_id?._id == activeProject}"
          class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-primary-500 dark:hover:bg-primary-500 group hover:text-white">
          <span [ngStyle]="{'background-color': project?.project_id?.color_code}"
            class="h-5 w-5 text-primary-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded dark:bg-primary-600 dark:text-primary-300"></span>
          <span class="ml-3">{{ project?.project_id?.name }}</span>

        </a>
      </ng-container>
    </li>
  </ul>
</div>